const { getAppConfig } = require('config/utils');

const { features } = getAppConfig(process.env.REACT_APP_NAME);

module.exports = { features };
